import { useState } from "react";
import CheckboxInput from "./CheckboxInput";
import TextInput from "./TextInput";
import "./SelectableItemInput.css";

const SelectableItemInput = ({
  title,
  items = [],
  value = [],
  onChange,
  showTaxable = false,
}) => {
  const [activeItem, setActiveItem] = useState(null);

  const [editIndex, setEditIndex] = useState(null);
  const isValidAmount = activeItem?.amount && Number(activeItem.amount) > 0;

  const totalAmount = value.reduce(
    (sum, item) => sum + Number(item.amount || 0),
    0
  );

  const addItem = () => {
    if (!activeItem?.amount) return;

    const updated = [...value, activeItem];
    onChange(updated);
    setActiveItem(null);
  };

  const removeItem = (index) => {
    onChange(value.filter((_, i) => i !== index));
  };

  const isSelected = (code) =>
    value.some((item) => item.code === code) || activeItem?.code === code;

  return (
    <>
      {/* Item Selection */}
      <div className="form-row">
        {items.map((item) => (
          <CheckboxInput
            key={item.id}
            label={item.name}
            checked={isSelected(item.id)}
            onChange={(_, checked) => {
              if (checked) {
                setActiveItem({
                  code: item.id,
                  label: item.name,
                  amount: "",
                  ...(showTaxable ? { isTaxable: false } : {}),
                });
              } else {
                setActiveItem(null);
              }
            }}
          />
        ))}
      </div>

      {/* Dynamic Item Details */}
      {activeItem && (
        <div className="payroll-item-config">
          <div className="payroll-item-config__header">
            <span className="payroll-item-config__title">
              {editIndex !== null ? "Edit" : "Add"} {activeItem.label}
            </span>
          </div>

          <div className="payroll-item-config__body">
            <div className="payroll-item-config__fields">
              {/* Amount Input with Currency */}
              <div className="payroll-item-config__amount">
                <label className="payroll-item-config__label">Amount</label>
                <div className="payroll-item-config__currency-input">
                  <span className="payroll-item-config__currency">₱</span>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={activeItem.amount}
                    onChange={(e) =>
                      setActiveItem({
                        ...activeItem,
                        amount: e.target.value,
                      })
                    }
                  />
                </div>
                {!isValidAmount && (
                  <span className="payroll-item-config__error">
                    Amount must be greater than zero
                  </span>
                )}
              </div>

              {/* Taxable Flag */}
              {showTaxable && (
                <div className="payroll-item-config__taxable">
                  <CheckboxInput
                    label="Taxable"
                    checked={activeItem.isTaxable}
                    onChange={(_, val) => {
                      setActiveItem({ ...activeItem, isTaxable: val });
                    }}
                  />
                </div>
              )}
            </div>

            {/* Actions */}
            <div className="payroll-item-config__actions">
              <button
                type="button"
                className="payroll-item-config__add-btn"
                disabled={!isValidAmount}
                onClick={() => {
                  if (!isValidAmount) return;

                  const updated = [...value];

                  if (editIndex !== null) {
                    updated[editIndex] = activeItem;
                  } else {
                    updated.push(activeItem);
                  }

                  onChange(updated);
                  setActiveItem(null);
                  setEditIndex(null);
                }}
              >
                {editIndex !== null ? "Update Item" : "Add Item"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Added Items List */}
      {value.length > 0 && (
        <div className="payroll-item-list">
          <div className="payroll-item-list__header">
            <span>Configured Items</span>
            <span className="payroll-item-list__total">
              Total: ₱{totalAmount.toFixed(2)}
            </span>
          </div>

          <ul className="payroll-item-list__items">
            {value.map((item, index) => (
              <li key={index} className="payroll-item-list__row">
                <div>
                  <strong>{item.label}</strong>
                  {showTaxable && (
                    <div className="payroll-item-list__meta">
                      {item.isTaxable ? "Taxable" : "Non-Taxable"}
                    </div>
                  )}
                </div>

                <div className="payroll-item-list__amount">
                  ₱{Number(item.amount).toFixed(2)}
                </div>

                <div className="payroll-item-list__actions">
                  <button
                    type="button"
                    onClick={() => {
                      setActiveItem(item);
                      setEditIndex(index);
                    }}
                  >
                    Edit
                  </button>

                  <button
                    type="button"
                    onClick={() =>
                      onChange(value.filter((_, i) => i !== index))
                    }
                  >
                    Remove
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default SelectableItemInput;
